import React, { useState, useEffect } from 'react';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { BASEURL } from '../../config';
import DataService from '../../lib/AxiosInstance';
import { getCategoryState, getLanguage } from '../../reduxFunction/appSlice';
import { useSelector } from 'react-redux';

const HomeCourseSlider = React.lazy(() => import('../Learn/HomeCourseSlider'));

// for next and pre
let PageNumber = 1;
let catID = 0;
let recordsPerPage = 10;
if (localStorage.getItem('screenwidth') > 767) {
    recordsPerPage = 20;
}
// for next and pre

function HomeSliderSkillsCourse() {
    const language = useSelector(getLanguage);
    const categoryState = useSelector(getCategoryState);
    const [IsLoaded, setIsLoaded] = useState(false);
    const [Sliders, setSliders] = useState([]);
   

    const fetchCourseData = async () => {
        try {
            const payload = JSON.stringify({
                MainCatID: 'skill',
                category: categoryState !== '' ? categoryState : catID,
                recordsPerPage,
                status: 1,
                PageNumber,
                sortby: 'popular',
                rahul: 'Yadav',
                language,
            });
            const res = await DataService.post(`/course/getAll`, payload);
            setIsLoaded(true);
            if (res.status === 200) {
                if (Object.keys(res.data.data).length > 0) {
                    setSliders(res.data.data);
                } else {
                    setSliders([]);
                }
            } else {
                console.log(res.data.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchCourseData();
    }, [language, categoryState]);

    return (
        <>
            <section className="appie-hero-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="appie-section-title text-left">
                                <h3 className="appie-title mb-1 mt-3">Highest-rated Courses</h3>
                                <p className="mb-2 d-none">
                                    {Number(localStorage.getItem('screenwidth')) > 550 ? (
                                        <>Magnify your skills with our most demanded courses</>
                                    ) : (
                                        ''
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: IsLoaded ? '' : 'none' }}>
                        <HomeCourseSlider
                            Sliders={Sliders}
                            key={Sliders.length}
                            ViewAllUrl={`${BASEURL}courses/skills-based-courses`}
                        />
                    </div>
                </div>
            </section>
        </>
    );
}

export default HomeSliderSkillsCourse;
